import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Breadcrumbs } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { NavigateNext } from '@material-ui/icons';

import { PORTFOLIO_PATH } from '../../routes';

const Root = styled.div`
	margin: 40px 0;

	a {
		font-weight: bold;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	.back {
		display: flex;
		align-items: center;
		font-size: 16px;

		svg {
			margin-right: 10px;
		}
	}

	.MuiBreadcrumbs-root {
		margin-top: 20px;
		color: ${(props) => props.theme.palette.blocks.breadcrumbs.color};
	}
`;

const DashboardPagnation = ({ projectName, branchLocation }) => (
	<Root>
		<Link to={PORTFOLIO_PATH} className="back">
			<ArrowBackIcon />
			Mein Portfolio
		</Link>
		{projectName !== '' && (
			<Breadcrumbs separator={<NavigateNext />}>
				<Link to={PORTFOLIO_PATH}>{projectName}</Link>
				<span>{branchLocation}</span>
			</Breadcrumbs>
		)}
	</Root>
);

export default DashboardPagnation;
